var _defs, _g, _g2, _circle, _circle2, _circle3, _circle4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 134.6 123.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .st0 {\n            fill: none;\n            stroke: #2e63ee;\n            stroke-linecap: round;\n            stroke-linejoin: round;\n            stroke-width: 2px;\n            }\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.9,21.9c-2.2-.2-4.4-.6-6.6-1.2-2.1-.5-4.2-1.1-6-2.3-1.8-1.2-3.3-2.9-3.8-5-.5-2.2.3-4.6,1.4-6.6,1.4-2.4,3.4-4.7,6-5.5,2.6-.8,5.5-.1,7.8,1.4s4,3.7,5.5,6c2.1,3.4,3.7,8.9,4.6,12.9,0,.1.1.1.2,0,.9-4,2.5-9.5,4.6-12.9,1.4-2.3,3.2-4.5,5.5-6,2.3-1.5,5.2-2.2,7.8-1.4,2.7.8,4.7,3.1,6,5.5,1.1,2,1.9,4.3,1.4,6.6-.4,2.1-2,3.9-3.8,5-1.8,1.2-3.9,1.8-6,2.3-2.2.5-4.4.9-6.6,1.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "73.3 43.7 73.3 84.9 6.6 84.9 6.6 43.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.9,37H1v-14.1c0-.6.5-1.1,1.1-1.1h75.8c.6,0,1.1.5,1.1,1.1v14.1h-31.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 46.7,
    y1: 21.9,
    x2: 46.7,
    y2: 84.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 33.2,
    y1: 84.9,
    x2: 33.2,
    y2: 21.9
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 90,
    y1: 110.2,
    x2: 49.2,
    y2: 110.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.2,37.1h22.8c3.8,0,7.3,2.4,8.6,6l15,38.2v28.9h-14.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.9,110.2h-7.8c-3.1,0-5.7-2.6-5.7-5.7v-12"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M133.6,81h-30.7c-3,0-5.4-2.4-5.4-5.4v-20.6h25.4"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 34.7,
    cy: 109.1,
    r: 13.5,
    transform: "translate(-67 56.5) rotate(-45)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 104.7,
    cy: 109.1,
    r: 13.5,
    transform: "translate(-46.1 98) rotate(-42)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 34.7,
    cy: 109.1,
    r: 13.5,
    transform: "translate(-67 56.5) rotate(-45)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 104.7,
    cy: 109.1,
    r: 13.5,
    transform: "translate(-46.1 98) rotate(-42)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyOrders);
export default __webpack_public_path__ + "static/media/my_orders.3b033b094976cb6c84971c67953c9c20.svg";
export { ForwardRef as ReactComponent };